<!--
 * @Author: Gaho
 * @Date: 2024-01-12 14:35:54
 * @LastEditors: Merlin
 * @LastEditTime : 2025-05-21 17:00:00
 * @Description: 
-->
<template>
    <NuxtLayout name="casino">
        <div class="circle-game">
            <!-- 顶部菜单 start -->
            <ClientOnly fallback-tag="span">
                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
                    <GameSettingsButtonLiveChat
                        v-if="userStore.isLoggedIn"
                        v-model="isOpenLiveChat"
                    />
                    <GameSettingsButtonFairness v-model="isOpenFairness" />
                    <GameSettingsButtonRule v-model="isOpenRule" name="circle" />
                    <GameSettingsButtonVocie
                        v-model="settingStore.inhouseGames.sound.on"
                        v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                        :saveAfterChange="true"
                    />
                </GameSettingsDiceTabsWrapper>
            </ClientOnly>
            <!-- 顶部菜单 end -->
            <!-- 游戏显示区域 start -->
            <div class="game-container">
                <div class="game-ring">
                    <ClientOnly>
                        <!-- circle-jackpot -->
                        <CircleJackpot :jackpotSize="globalStore?.jackpotSum['circle']"></CircleJackpot>
                        <!-- 历史下注结果 -->
                        <CircleResults :historyData="circleHistoryData"></CircleResults>
                    </ClientOnly>
                    <!-- 轮盘区域 -->
                    <ClientOnly>
                        <CircleBoard
                            :borderColor="borderColor"
                            :degrees="degrees"
                            :arrowDownColor="arrowDownColor"
                            :showTime="showTime"
                            :formattedNumber="formattedNumber"
                            :circleStateLabel="circleStateLabel"
                        />
                    </ClientOnly>
                    <ClientOnly>
                        <circleBetHistory
                            :betArray="betArray"
                            :circleResult="circleResult"
                            :borderColor="borderColor"
                            :lastResult="lastResult"
                        />
                    </ClientOnly>
                </div>
                <!-- 下注区域 -->
                <ClientOnly>
                    <CircleForm
                        :formOptions="formOptions"
                        :circleState="circleState"
                        @handleBet="handleBet"
                        @handleToggle="handleToggle"
                        @handleFormBtn="handleFormBtn"
                    />
                </ClientOnly>
            </div>
        </div>
        <ModalWinJackpot v-model="winJackpotVisible" :data="winJackpotData" />
    </NuxtLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// stores & sockets
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { type cicleStateTypes, type circleResultTypes } from '@/socket/game/circle';
import { useGameSocket } from '@/socket/game';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJackPotSocket } from '@/socket/jackpot';
import useGlobalStore from '@/stores/global';
// components
import CircleForm from './_components/circleForm/index.vue';
import CircleJackpot from './_components/jackpot/index.vue';
import CircleResults from './_components/circleResults/index.vue';
import CircleBoard from './_components/circleBoard/index.vue';
import circleBetHistory from './_components/circleBetHistory/index.vue';
// functions
import { useI18n } from 'vue-i18n';
import betHelper from '@/common/js/betHelper';
import { getGameApi } from '@/common/js/gameAbout';
// mock data
import { circleSectors, circleColor, type formType } from './data';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';

export default defineComponent({
    name: 'circleGame',
    components: {
        CircleForm,
        CircleResults,
        CircleJackpot,
        CircleBoard,
        circleBetHistory,
    },
    data() {
        return {
            $t: useI18n().t,
            isOpenLiveChat: false, // 右侧统计
            isOpenFairness: false, // 公平性弹框
            isOpenRule: false, // 规则弹框
            settingStore: useSettingsStore(),
            gameStore: useSettingsStore().game,
            userStore: useUserStore(),
            joinStore: useJoinStateStore(),
            globalStore: useGlobalStore(),
            oForm: {
                amount: 0,
                isSubmiting: false,
            },
            formOptions: [
                {
                    multi: 0, // 返现倍数；将使用接口返回值为其赋值 
                    maxWin: 0, // 返现上限；将使用接口返回值为其赋值 
                    key: 'gray',
                    auto: false,
                    value: '0.00',
                    disabled: true,
                    sector: 1,
                    isSubmiting: false,
                },
                {
                    multi: 0,
                    maxWin: 0,
                    key: 'red',
                    auto: false,
                    value: '0.00',
                    disabled: true,
                    sector: 2,
                    isSubmiting: false,
                },
                {
                    multi: 0,
                    maxWin: 0,
                    key: 'green',
                    auto: false,
                    value: '0.00',
                    disabled: true,
                    sector: 3,
                    isSubmiting: false,
                },
                {
                    multi: 0,
                    maxWin: 0,
                    key: 'yellow',
                    auto: false,
                    value: '0.00',
                    disabled: true,
                    sector: 4,
                    isSubmiting: false,
                },
            ],
            // 游戏状态，进入游戏后会立即更新此值 
            circleState: {
                name: 'STOP_BETTING',
                end: null,
            },
            // 游戏结果
            circleResult: {
                win_sector: null,
            },
            currentNumber: 15,
            startTime: null,
            duration: 15 * 1000, // 下注持续时间
            animationFrameTimer: null,
            animationFrameRing: null,
            startNumber: 15,
            circleSpeed: 0.1, // 圆盘旋转速度
            circleAcel: 0.05, // 圆盘加速度
            maxX: 0,
            circleStones: [], // 转盘上每块区域的数据
            interval: 0, // 转盘旋转间隔
            startAng: 0, // 开始角度
            degrees: 1, // 旋转度数
            circleMaxSpeed: 4, // 转盘最大旋转速度
            borderColor: 'rgb(27, 34, 51)', // 转盘边框颜色
            lastResult: 0, // 上一轮结果
            soundOptions: {},
            musicControler: null,
            timeSoundTimer: null,
            betsTimer: null,
            delayTime: 0,
            circleHistoryData: [], // 历史下注结果
            betArray: [], // 暂存下注结果
            winJackpotVisible: false,
            winJackpotData: {},
            aChannelCloser: [], // 内含监听关闭器 
        };
    },
    computed: {
        // 当前下注状态对应的翻译
        circleStateLabel() {
            let label = '';
            switch (this.circleState.name) {
                case 'BETTING': // 下注阶段
                    label = this.$t('placeBet');
                    break;
                case 'STOP_BETTING': // 停止下注
                    label = this.$t('stopBet');
                    break;
                case 'SHOW_RESULT': // 获取下注结果
                    label = this.$t('showResult');
                    break;
                case 'PREPARING_NEXT_ROUND': // 下一次下注准备阶段
                    label = this.$t('nextRound');
                    break;
                default:
                    label = this.$t('stopBet');
            }
            return label;
        },
        // 格式化日期
        formattedNumber() {
            return (this.currentNumber ?? 0).toFixed(2);
        },
        showTime() {
            return !['STOP_BETTING', 'SHOW_RESULT', 'PREPARING_NEXT_ROUND'].includes(
                this.circleState.name,
            );
        },
        // 当前扇区对应的下标
        currentSectorIndex() {
            const degree = this.degrees % 360;
            return Math.floor(degree / (360 / circleSectors.length));
        },
        // 箭头颜色
        arrowDownColor() {
            return circleColor[circleSectors[this.currentSectorIndex] - 1];
        },
    },
    watch: {
        // 监听音效开关 是否播放背景音乐
        'settingStore.inhouseGames.sound.on': {
            handler(newVal){
                if (newVal && !this.musicControler){
                    // 音效初始化
                    this.getSounds();
                }
            },
            immediate: true,
        },
        // 获取并设置当前游戏阶段
        'joinStore.state': {
            handler(newVal) {
                if (import.meta.server) return; 
                const toSetVal = newVal && Object.keys(newVal).length;
                if (!toSetVal) return; 
                if (newVal.name === 'BETTING' && newVal.end - Date.Now() < 0) {
                    console.log('入场赋值终止 1：', newVal.end - Date.getReal().getTime(), '💥💥');
                    return;
                }
                const oldEnd = this.circleState.end;
                if (oldEnd && (newVal.end <= oldEnd)){
                    console.log('入场赋值终止 2：', newVal.end - oldEnd, '💥💥');
                    return;
                }
                console.log('入场状态：', newVal.name, '💲💲💲');
                this.circleState = {...newVal, ts_: Date.Now()};
            },
            deep: true,
            immediate: true,
        },
        // 当前下注阶段的投注记录
        'joinStore.bets': {
            handler(newVal) {
                this.betsTimer = setTimeout(() => {
                    const currentUserId = this.userStore._id || this.userStore.id;
                    if (newVal?.length) {
                        const currentUserBets = newVal.filter((item) => {
                            return item.user._id === currentUserId;
                        });
                        this.betArray = currentUserBets;
                    }
                }, 100);
            },
            deep: true,
            immediate: true,
        },
        // ↓ 监听配置信息的加载事件 
        'joinStore.config': {
            handler(newVal) {
                // console.log('joinStore.config', deepCopy(newVal?.sectors));
                if (import.meta.server || !newVal?.sectors) {
                    return;
                }
                this.handleFormatFormOptions();
            },
            deep: true,
            immediate: true,
        },
        // 监听游戏状态，进入游戏时会立即更新此值 
        'circleState': {
            async handler(newVal) {
                if (import.meta.server) return;
                console.log('[circleState] changed to:', JSON.stringify(newVal)); 
                switch (newVal.name) {
                    case 'BETTING':
                        await this.initTimeData(newVal.end);
                        if (1 && import.meta.env.DEV_MODE){
                            console.log('\n\n🚩 新一轮启动 BETTING');
                            console.log('End at---', new Date(newVal.end).toLocaleString());
                            console.log('Duration:', (this.duration/1000).toFixed(1) + 's');
                        }
                        this.betArray = [];
                        this.borderColor = 'rgb(27, 34, 51)';
                        // BETTING下注阶段取消所有form的禁用状态disabled=false
                        this.formOptions = this.formOptions.map((item) => ({
                            ...item,
                            disabled: false,
                        })) as formType[];
                        // 获取开启自动下注的form，如果有的话则全部进行下注
                        const formSubmittings = this.formOptions.filter((item) => item.isSubmiting);
                        if (formSubmittings.length) {
                            this.betSubmit(formSubmittings);
                        }
                        this.startTimeAnimation();
                        break;
                    case 'STOP_BETTING':
                        // 关闭数字倒计时动画效果及对应的音效
                        this.animationFrameTimer && cancelAnimationFrame(this.animationFrameTimer);
                        this.timeSoundTimer && clearInterval(this.timeSoundTimer);
                        this.timeSoundTimer = null;
                        this.musicControler?.oAudio?.timerSound?.stop();

                        // this.joinStore.gameRunning = false;
                        this.formOptions = this.formOptions.map((item) => ({
                            ...item,
                            disabled: true,
                        }));
                        break;
                    case 'SHOW_RESULT':
                        // await Sleep(this.delayTime);
                        // this.startRingAnimation();
                        break;
                    case 'PREPARING_NEXT_ROUND':
                        this.joinStore.gameRunning = false;
                        this.stopRingAnimation(this.lastResult);
                        this.animationFrameRing && cancelAnimationFrame(this.animationFrameRing);
                        // 显示当前下注结果并且将其余按钮禁用
                        const sector = circleSectors[this.lastResult] - 1;
                        this.formOptions = this.formOptions.map((item, index) => ({
                            ...item,
                            disabled: index !== sector,
                        }));
                        // 设置转盘边框颜色并播放完成音效
                        this.borderColor = this.arrowDownColor;
                        this.musicControler?.oAudio.finishSound.toPlay();
                        this.getCircleHistory();
                        this.initTimeData();
                        break;
                    default:
                }
            },
            immediate: true,
        },
        'arrowDownColor'() {
            if (Math.round(this.degrees / (360 / circleSectors.length)) % 2) {
                this.musicControler?.oAudio?.rouletteSound?.toPlay();
            }
        },
        'currentNumber'(newVal) {
            // 防止出现下注时间已结束，但后端接口没有实时更新状态的情况
            // 前端手动切换到STOP_BETTING状态
            if (this.circleState.name === 'BETTING' && newVal === 0) {
                this.circleState = {
                    name: 'STOP_BETTING',
                    end: null,
                };
            }
        },
        // 监听货币切换，重置下注金额
        async 'settingStore.pickedCurrency'(newVal, oldVal) {
            if (newVal !== oldVal) {
                const {hasLogged} = await getUserInfo();
                this.formOptions = this.formOptions.map((form) => ({
                    ...form,
                    value: hasLogged
                        ? String(betHelper.getCurrentDefaultBetAmount())
                        : '0.00',
                }));
            }
        },
        formOptions: {
            handler(aNewData){
                if (import.meta.server) return; 
                const $t = useNuxtApp().$i18n.t;
                aNewData.filter(cur=>{
                    return ( // 满足所有条件才能启动金额适当性监测 
                        cur.multi &&
                        cur.maxWin && 
                        cur.disabled == false && 
                        Number(cur.value) > 0
                    );
                }).forEach((cur) => {
                    const fTargetWinAmount = Number(cur.value) * cur.multi;
                    // ↓ 预测提现金额未超限，返回 
                    if (fTargetWinAmount <= cur.maxWin) return;
                    const sMax = number2LocaleString(cur.maxWin);
                    const sCurrency = this.settingStore.pickedCurrency.toUpperCase();
                    const sArea = cur.multi.toFixed(2);
                    let message =  `[${$t(cur.key)}] `;
                    message += $t('commonInfo.payoutOverLimit', {
                        limit: `${sMax} ${sCurrency} (${sArea}x)`,
                    });
                    console.log(cur.key, message); 
                    showNegativeNotify({
                        message,
                        type: 'warning',
                        position: 'top',
                    });
                });
            },
            deep: true,
            immediate: true,
        }
    },
    mounted() {
        this.initData();
        this.onCircleState();
        this.onCircleResult();
        this.handleOnWinJackpot();
        this.toSetState();
    },
    beforeUnmount(){
        cancelAnimationFrame(this.animationFrameTimer);
        cancelAnimationFrame(this.animationFrameRing);
        clearInterval(this.timeSoundTimer);
        this.timeSoundTimer = null;
        this.musicControler?.toDestory();
        this.aChannelCloser.forEach(fnCloser => {
            if (fnCloser) fnCloser();
        });
    },
    methods: {
        /**
         * 初始化转盘每一块扇形区域的数据
         */
        initData() {
            this.interval = ((360 / circleSectors.length) * Math.PI) / 180;
            for (let i = 0; i < circleSectors.length; i++) {
                this.circleStones.push({
                    type: circleSectors[i],
                    ang: Math.floor((this.startAng / Math.PI) * 180),
                    x: (365 / 2) * Math.sin(this.startAng) + 365 / 2,
                    y: (365 / 2) * Math.cos(this.startAng) + 365 / 2,
                });
                this.startAng += this.interval;
            }
        },
        /**
         * 更新 state 值，防止切换语言时舞台状态不正确  
         */
        async toSetState(){
            const { EMIT_GAME_JOIN } = useGameSocket();
            const {promise, resolve} = createPromise();
            EMIT_GAME_JOIN(getGameApi(), {}, resolve);
            const oData = await promise;
            const oNewState = oData?.['state'];
            const oOldState = this.joinStore?.state;
            console.log('\n 旧', JSON.stringify(oOldState), '\n 新', JSON.stringify(oNewState));
            if (!oNewState || !oOldState) return;
            const iGap = oNewState.end - oOldState['end'];
            console.log('新值领先时间：', (iGap/1000).toFixed(1), 's'); 
            if (iGap > 0){
                Object.assign(this.joinStore.state, oNewState);
            }
        },
        /**
         * 初始化下注时间
         * 刚进游戏时如果正好处于下注阶段，则取 当前时间 到 下注结束时间的间隔，否则默认为15s
         * @param end 当前阶段结束时间
         */
        async initTimeData(end?: number) {
            if (end) {
                // 当前时间
                const nowTime = Date.Now();
                // 到结束阶段剩余的时间，最大值设为20秒，防止用户本地时间不正确 
                let delay = Math.min(20_000, end - nowTime);
                if (delay < 0){
                    delay = 20_000; // 容错，应对用户设备时间不准的情况 
                }
                this.duration = delay;
                const num = Number((delay / 1000).toFixed(2));
                this.currentNumber = num;
                this.startNumber = num;
            } else {
                this.currentNumber = 15;
                this.duration = 15 * 1000;
                this.startNumber = 15;
            }
            this.startTime = null;
        },
        /**
         * 加载mp3资源
         */
        getSounds() {
            const circleSounds = import.meta.glob('@/assets/mp3/circle/*.mp3', { eager: true });
            const simpleClick = import.meta.glob('@/assets/mp3/simple_click.mp3', {
                eager: true,
            }) as any;
            Object.entries(circleSounds).forEach(([key, value]: any[]) => {
                const keys = `${key.split('/').pop().split('.').shift().split('-')[1]}Sound`;
                this.soundOptions[keys] = {
                    src: value.default,
                };
            });
            this.soundOptions = {
                ...this.soundOptions,
                simpleClick: {
                    src: Object.values(simpleClick)[0]?.default,
                },
            };
            // console.log(this.soundOptions, 'this.soundOptions');
            this.musicControler = new MusicControler(this.soundOptions);
            // console.log(this.musicControler, 'this.musicControler');
        },
        /**
         * 监听游戏状态
         */
        onCircleState() {
            const { ON_CIRCLE_STATE } = useGameSocket();
            const fnCloser = ON_CIRCLE_STATE((res: cicleStateTypes) => {
                this.circleState = res as cicleStateTypes;
            });
            this.aChannelCloser.push(fnCloser);
        },
        /**
         * 监听游戏下注结果
         */
        onCircleResult() {
            const { ON_CIRCLE_RESULT } = useGameSocket();
            const fnCloser = ON_CIRCLE_RESULT((res: circleResultTypes) => {
                this.startRingAnimation(res);
            });
            this.aChannelCloser.push(fnCloser);
        },
        /**
         * 获取历史下注结果
         * 在游戏状态切换为 PREPARING_NEXT_ROUND 时调用此方法 
         */
        getCircleHistory() {
            const { EMIT_CIRCLE_HISTORY } = useGameSocket();
            const gameHistoryStore = useGameHistoryStore();
            EMIT_CIRCLE_HISTORY({}, (res) => {
                if (!res || res.error){
                    return console.error('查询 circle 游戏历史数据失败');
                }
                this.circleHistoryData = res;
                // 实时更新开奖结果，在result、history中展示
                this.joinStore.history = {
                    all: res.all,
                    rare: res.rare,
                    high: res.high,
                    my: res.my || [],
                    fun: res.fun,
                };
                // 更新My Bets和实时图表下注数据
                gameHistoryStore.setState({
                    historyData: {
                        ...gameHistoryStore.historyData,
                        response: res.my,
                        count: ++gameHistoryStore.historyData.count,
                    },
                });
                // 清空实时下注数据
                this.joinStore.setBetsOnline();
            });
        },
        /**
         * 时间滚动动画
         */
        startTimeAnimation() {
            const animate = (currentTime: number) => {
                // 设置当前动画效果的开始时间
                if (!this.startTime) {
                    this.startTime = currentTime;
                }
                // 计算当前动画进度 elapsedTime--动画执行时间 duration--动画总时间 progress--动画进度
                const elapsedTime = currentTime - this.startTime;
                const progress = elapsedTime / this.duration;
                if (progress < 1) {
                    this.currentNumber = this.startNumber - this.startNumber * progress;
                    this.animationFrameTimer = requestAnimationFrame(animate);
                } else {
                    // 动画结束
                    this.currentNumber = 0;
                    this.startTime = null;
                    cancelAnimationFrame(this.animationFrameTimer);
                    this.musicControler?.oAudio?.timerSound?.stop();
                }
            };
            this.animationFrameTimer = requestAnimationFrame(animate);
            this.timeSoundTimer = setInterval(() => {
                this.musicControler?.oAudio?.timerSound?.toPlay();
            }, 220);
        },
        /**
         * 游戏转盘滚动动画
         */
        handleRingAnimation() {
            if (this.maxX) {
                const remainingDistance = this.maxX - this.degrees;
                this.circleSpeed = remainingDistance * 0.03;
            } else {
                this.circleSpeed += this.circleAcel;
            }

            if (this.circleSpeed >= this.circleMaxSpeed) {
                this.circleSpeed = this.circleMaxSpeed;
            }
            if (!this.maxX && this.currentSectorIndex === this.circleResult.win_sector) {
                this.degrees = this.circleStones[this.circleResult.win_sector].ang;
                this.maxX = this.degrees + 361;
            }

            if (this.circleState.name === 'SHOW_RESULT') {
                this.degrees += this.circleSpeed;
                this.animationFrameRing = window.requestAnimationFrame(this.handleRingAnimation);
            } else {
                this.degrees -= this.circleSpeed;
            }
        },
        /**
         * 开启游戏转盘滚动动画
         */
        async startRingAnimation(res: circleResultTypes) {
            this.circleSpeed = 0.1;
            this.maxX = 0;
            // 下注结果
            this.circleResult = {
                ...res,
                win_sector: Number(res.win_sector),
            };
            // 上一次的下注结果
            this.lastResult = Number(res.win_sector);
            this.animationFrameRing = window.requestAnimationFrame(this.handleRingAnimation);
        },
        // 停止转盘滚动动画
        stopRingAnimation(index = 0) {
            if (this.circleStones.length) {
                this.degrees = this.circleStones[index].ang + 1;
            }
        },
        /**
         * 调用下注接口
         * @param form { formType } 下注倍数
         */
        async handleEmitCircleBet(form: formType, index: number) {
            await Sleep((index || 0) * 100);
            const iVal = Number(form.value || 0);
            const {balance=0} = this.userStore.oNowCurrency; 
            const $tFn = useNuxtApp().$i18n.t;
            if (!iVal || (iVal > balance)){
                console.log(`余额不足【${form.key}】已经终止`, deepCopy(form));
                const autoMode = (form.auto || form.isSubmiting);
                this.formOptions.forEach(cur=>{
                    if (cur.key != form.key) return;
                    cur.auto = false;
                    cur.isSubmiting = false;
                });
                const min = betHelper.getMinBetAmout(form.key); 
                const sField =  `[${$tFn(form.key)}] `;
                const message = (
                    iVal < min
                    ? (sField + $tFn('commonInfo.amountTooLess', {min}))
                    : (
                        autoMode
                        ? (sField + $tFn('betAmountTips'))
                        : (sField + $tFn('commonInfo.noBlance'))
                    )
                );
                showNegativeNotify({
                    message,
                    position: 'top',
                    type: 'warning',
                });
                return;
            }
            const { EMIT_CIRCLE_BET } = useGameSocket();
            const params = {
                sector: form.sector,
                amount: form.value,
                frontID: Date.Now(),
            };
            const isAuto = Boolean(form.auto);
            const iTryTimes = isAuto ? 2 : 1;
            console.log(`将下注：🚩sector[${form.sector}]->`, isAuto ? '自动模式--' : '手动模式');
            for (let ii = 0; ii < iTryTimes; ii++) {
                const {promise, resolve} = createPromise();
                const willTryAgain = (ii === 0) && isAuto; // 启动重试
                // if (import.meta.env.DEV_MODE){ 
                //     params.amount = Math.random() <= 0.3 ? '0' : String(form.sector); 
                // }
                const amountMemory = useAmountMemoryStore();                    
                amountMemory.setCircleLastAmount(form.value,form.key);     
                params.frontID = Date.Now(); // 执行更新，以利于自动模式二次请求 
                EMIT_CIRCLE_BET(params, (res) => {
                    // 下注失败
                    if (!res || res.code) {
                        resolve(false);
                        // ↓ 跳过以下操作，因为将会二次请求  
                        if (willTryAgain) return; 
                        showNegativeNotify(res?.error);
                        this.joinStore.gameRunning = false;
                        if (this.formOptions.find(item => item.isSubmiting === form.isSubmiting)){
                            this.formOptions[form.sector - 1].isSubmiting = false;
                        }
                        
                    } else {
                        this.betArray.push(res);
                        resolve(true);
                    }
                });
                const isOK = await promise;
                console.log(`第 ${ii+1} 次请求：`, isOK ? '成功了' : '失败'); 
                if (isOK) break; // 成功了，就中断循环 
            }
        },
        /**
         * 下注
         */
        betSubmit(formArr?: formType[]) {
            if (formArr.length) {
                this.joinStore.gameRunning = true;
                formArr.forEach((form, index) => {
                    this.handleEmitCircleBet(form, index);
                });
            }
        },
        /**
         * 点击下注按钮
         */
        async handleBet(form: formType) {
            if (this.circleState.name !== 'BETTING') {
                return;
            }
            if(1 && import.meta.dev){
                console.log('下注目标：', form.key); 
            }
            const currentSector = form.sector - 1;
            // 是否已切换为自动下注
            if (this.formOptions[currentSector].auto) {
                // auto=true则切换按钮状态isSubmiting -> !isSubmiting
                this.formOptions[currentSector].isSubmiting =
                    !this.formOptions[currentSector].isSubmiting;
                // 当isSubmiting变成true时，则开始自动下注
                if (this.formOptions[currentSector].isSubmiting) {
                    this.betSubmit([form]);
                }
            } else {
                // auto=false 仅单次下注
                // 防止连续点击下注
                this.formOptions[currentSector].disabled = true;
                this.betSubmit([form]);
                await Sleep(2_000);
                if (this.circleState.name === 'BETTING') {
                    this.formOptions[currentSector].disabled = false;
                }
            }
        },
        /**
         * 自动开关切换
         */
        handleToggle(form: formType) {
            const { sector, auto } = form;
            // 如果auto=false,则关闭当前form自动下注功能(isSubmiting=false)
            if (!auto) {
                this.formOptions[sector - 1] = {
                    ...this.formOptions[sector - 1],
                    isSubmiting: false,
                };
            }
            this.gameStore.circle[sector - 1] = auto;
        },
        /**
         * 点击按钮处理下注数值变化
         * @param type '/2' | 'x2' | 'max' 按钮类型
         * @param form 当前form下注的相关数据
         */
        handleFormBtn(type: string, form: formType, newVal?: string) {
            let { sector, value, key } = form;      
            switch (type) {
                case '/2':
                    const [halfValue, toast01] = betHelper.onHalfClick(value, key);
                    showToastIfNeeded(toast01);
                    this.formOptions[sector - 1].value = getFixed(halfValue).toString();
                    break;
                case 'x2':
                    const [doubleValue, toast02] = betHelper.onDoubleClick({
                        currentBalance: this.userStore.oNowCurrency.balance,
                        maxBetAmount: betHelper.getMaxBetAmout(1, key),
                        betAmount: Number(value),
                    });
                    showToastIfNeeded(toast02);
                    this.formOptions[sector - 1].value = getFixed(doubleValue).toString();
                    break;
                case 'max':
                    const [maxValue, toast03] = betHelper.onMaxClick({
                        currentBalance: this.userStore.oNowCurrency.balance,
                        maxBetAmount: betHelper.getMaxBetAmout(1, key),
                    });
                    showToastIfNeeded(toast03);
                    this.formOptions[sector - 1].value = getFixed(maxValue).toString();
                    break;
                case 'blur':
                    this.formOptions[sector - 1].value = getFixed(value).toString();
                    break;
                case 'chips':
                    this.formOptions[sector - 1].value = getFixed(value).toString();
                    break;
                case 'input': 
                    this.formOptions[sector - 1].value = newVal.toString();
                    break;
                default:
            }
            if (1 && import.meta.dev){
                console.log(`${key} 操作后金额：`, this.formOptions[sector - 1].value);
            }
        },
        /**
         * 监听jackpot赢分
         */
        handleOnWinJackpot() {
            const { ON_WINJACKPOT } = useJackPotSocket();
            const fnCloser = ON_WINJACKPOT('circle', (res) => {
                if (res.jackpot.user.username === this.userStore.name) {
                    this.winJackpotData = {
                        ...res.jackpot,
                        game: 'circle',
                    };
                    this.winJackpotVisible = true;
                }
            });
            this.aChannelCloser.push(fnCloser);
        },
        /**
         * 设置初始默认下注金额
         */
        async handleFormatFormOptions() {
            const {hasLogged} = await getUserInfo(); 
            const { config } = this.joinStore;
            const { pickedCurrency } = this.settingStore;
            const sectors = config[pickedCurrency]?.sectors;
            console.log('sectors ↓\n', deepCopy(sectors)); 
            this.formOptions = this.formOptions.map((form, index) => {
                const oSetting = sectors[form.key]; 
                const amountMemory = useAmountMemoryStore();
                const lastAmount = amountMemory.getCircleLastAmount(form.key);
                
                const value = ( // 下注金额默认值 
                    hasLogged
                    ? getFixed(lastAmount || oSetting?.defaultBet).toString()
                    : '0.00'
                );
                const oResult = ({
                    ...form,
                    multi: oSetting?.multiplier ?? form.multi,
                    maxWin: oSetting.maxWin,
                    value,
                    auto: this.gameStore.circle[index] || false,
                });
                return oResult;
            });
        },
    },
});
</script>

<style lang="scss" scoped>
.circle-game {
    width: 100%;
    min-height: 400px;
    @media (max-width: 768px) {
        padding: 2px 0px 0px;
    }
    .game-col-controls {
        width: 100%;
        max-width: 650px;
        margin: 0 auto;

        .button-settings {
            cursor: pointer;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 12px;
            margin-top: 2px;
            width: 100%;

            & > :deep(div) {
                flex: none;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        @media (max-width: 1000px) {
            .button-settings {
                justify-content: flex-start;

                & > :deep(div) {
                    flex: 1;
                }
            }
        }
    }
    .game-container {
        width: 100%;

        .game-ring {
            display: block;
            margin-bottom: 25px;
            position: relative;
            width: 100%;
            user-select: none;
        }
    }
}
</style>